var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.630109 20.0362C-0.102989 21.3691 0.861336 23 2.38254 23H23.1175C24.6387 23 25.603 21.3691 24.8699 20.0362L14.5024 1.18624C13.7426 -0.195312 11.7574 -0.195311 10.9976 1.18624L0.630109 20.0362ZM14 17.8026C14 18.493 13.4404 19.0526 12.75 19.0526C12.0596 19.0526 11.5 18.493 11.5 17.8026V17.6711C11.5 16.9807 12.0596 16.4211 12.75 16.4211C13.4404 16.4211 14 16.9807 14 17.6711V17.8026ZM14 12.5395C14 13.2298 13.4404 13.7895 12.75 13.7895C12.0596 13.7895 11.5 13.2298 11.5 12.5395V9.77632C11.5 9.08596 12.0596 8.52632 12.75 8.52632C13.4404 8.52632 14 9.08596 14 9.77632V12.5395Z",
    fill: "#FF574C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.bd064291801bfae8d43e410cbf691cf4.svg";
export { ForwardRef as ReactComponent };